import { ActivityBuilderDrawerLoading } from 'approot/activity-builder/activity-builder-drawer';
import { useGetStimulusResource } from 'approot/shared/stimulus/stimulus.hooks';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import type { GetStimulusResourceQuery } from '../../../shared/stimulus/stimulus.graphql.generated';
import { Props } from './interactive-settings.constants';
import InteractiveEditPreview from './interactive-edit-preview';
import type { Pluck } from 'lib/gql/pluck';

const InteractiveEditDrawer = ({
  id,
  properties,
  title,
  lessonId,
  sectionId,
}: Props & {
  title: string;
}) => {
  const { closeDrawer } = useActivityBuilderContext();

  const { data, loading } = useGetStimulusResource(
    properties.stimulusId!,
    true
  );

  const stimulus = data?.getStimulusResource as Extract<
    Pluck<GetStimulusResourceQuery, 'getStimulusResource'>,
    { __typename: 'StimulusResourceInteractive' }
  >;

  return loading ? (
    <ActivityBuilderDrawerLoading title={title} onClose={closeDrawer} />
  ) : (
    <InteractiveEditPreview
      componentId={id}
      sectionId={sectionId}
      stimulus={stimulus}
      title={title}
      contentId={lessonId}
    />
  );
};

export default InteractiveEditDrawer;
